export default __webpack_public_path__ + "static/media/Athletics.8d1dd33d.png";